export const BOOKING_QUOTES_ROUTE_PREFIX: string = '/dashboard/booking-quotes';

interface BookingQuotesRoutes {
  index: {
    getUrl: (scopeSlug?: string) => string;
    path: string;
    relativePath: string;
  };
}

const bookingQuotesRoutes: BookingQuotesRoutes = {
  index: {
    path: `${BOOKING_QUOTES_ROUTE_PREFIX}/:scope?`,
    getUrl: (scopeSlug?: string): string => {
      if (!scopeSlug) {
        return BOOKING_QUOTES_ROUTE_PREFIX;
      }

      return `${BOOKING_QUOTES_ROUTE_PREFIX}/${scopeSlug}`;
    },
    relativePath: 'booking-quotes/:scope?'
  }
};

export default bookingQuotesRoutes;
